// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1eK_VhDpS1r9rJU2cDcalW","message":"_1vDdcZOtCbJtWAo1XuBAm3","chatimage":"_3o4PkpitzT7zNSQd11zVxz"};